import * as actionTypes from './actionTypes';

export const togglePartner4DShareUpdate=()=>{
      return {
            type:actionTypes.TOGGLE_PARTNER_4D_SHARE_UPDATE
      }
}